import React from 'react';
import { castCrew } from '../recs/engine';
import { initials } from '../utils/initials';
import './CastCrew.css';

interface Props {
  titleId: string;
}

export default function CastCrew({ titleId }: Props) {
  const credits = castCrew
    .filter((c) => c.title_id === titleId)
    .sort((a, b) => a.billing_order - b.billing_order);

  if (credits.length === 0) return null;

  return (
    <div className="cast-crew">
      <p className="cast-crew__label">Cast &amp; Crew</p>
      <ul className="cast-crew__list">
        {credits.map((c) => (
          <li key={c.credit_id} className="cast-crew__entry">
            <span className="cast-crew__avatar" aria-hidden="true">
              {initials(c.person_name)}
            </span>
            <span className="cast-crew__info">
              <span className="cast-crew__name">{c.person_name}</span>
              <span className="cast-crew__role">{c.role}</span>
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
